import { useEffect, useState } from "react";
import { useSearchParams, useOutletContext } from "react-router-dom";
import { Search } from "lucide-react";
import { api } from "@/lib/appApi";
import NewsCard from "@/components/public/NewsCard";
import { Button } from "@/components/ui/button";

export default function SearchPage() {
  const [params, setParams] = useSearchParams();
  const { unitMap = {} } = useOutletContext() || {};
  const q = params.get("q") || "";
  const [input, setInput] = useState(q);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!q) { setItems([]); return; }
    setLoading(true);
    api.get("/public/articles", { params: { q, limit: 30 } }).then((r) => setItems(r.data.items)).finally(() => setLoading(false));
  }, [q]);

  const submit = (e) => { e.preventDefault(); setParams(input.trim() ? { q: input.trim() } : {}); };

  return (
    <div className="max-w-5xl mx-auto px-4 py-10">
      <h1 className="font-serif text-3xl font-extrabold text-dlh-green mb-4">Pencarian</h1>
      <form onSubmit={submit} className="flex gap-2 mb-8">
        <div className="relative flex-1">
          <Search className="absolute left-4 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-400" />
          <input value={input} onChange={(e) => setInput(e.target.value)} data-testid="search-page-input" autoFocus
            placeholder="Cari berita terbit…" className="w-full rounded-full border border-gray-300 pl-12 pr-4 py-3 text-base focus:outline-none focus:ring-2 focus:ring-dlh-orange" />
        </div>
        <Button type="submit" className="bg-dlh-green hover:bg-dlh-greenDark rounded-full px-8">Cari</Button>
      </form>

      {q && <p className="text-sm text-gray-500 mb-4">Hasil untuk “{q}”: {items.length} berita.</p>}
      {loading ? <p className="text-gray-500">Memuat…</p> : items.length === 0 && q ? (
        <div className="rounded-xl border border-dashed border-gray-300 p-12 text-center text-gray-500">Tidak ada berita terbit yang cocok.</div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">{items.map((a) => <NewsCard key={a.id} article={a} unitMap={unitMap} />)}</div>
      )}
    </div>
  );
}
